module.exports = __webpack_public_path__ + "static/media/arrow_right_order.fe33a099.svg";